import React, { useState } from "react";
import { FaClipboard } from "react-icons/fa";
import "./SignHashForm.css";
import ConnectWalletButton from "./ConnectWalletButton";

function SignHashForm({
  recoveryHash,
  onSignHash,
  isConnected,
  isLoading,
  signature,
}) {
  const [copied, setCopied] = useState(false);

  const handleSign = async () => {
    await onSignHash(recoveryHash.hash);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(signature).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="sign-form">
      <h2>Sign Recovery Hash</h2>
      <ConnectWalletButton />
      <p>AXR Wallet Address: {recoveryHash.walletAddress}</p>
      <p>Recovery Hash: {recoveryHash.hash}</p>
      <button onClick={handleSign} disabled={!isConnected}>
        {isLoading ? "Signing..." : "Sign Hash"}
      </button>
      {signature && (
        <div className="signature-result">
          <h3>Generated Signature</h3>
          <div className="hash-container" onClick={copyToClipboard}>
            <span>{signature}</span>
            <FaClipboard className="clipboard-icon" />
          </div>
          {copied && <div className="copied-message">Copied to clipboard!</div>}
        </div>
      )}
    </div>
  );
}

export default SignHashForm;
